import { Routes, Route } from 'react-router-dom';

import Header from '../../header';
import Footer from '../../footer';
import ScrollToTop from '../../ScrollToTop';

import Login from '../login';
import Signup from '../Signup';

import HomePage from '../home';

import BookAppointment from '../booking/BookAppointment';
import BookingSuccess from '../booking/BookingSuccess';
import MyBookings from '../booking/MyBookings';

import PriceList from '../price-list/PriceList';
import Services from '../services/Services';
import EWaste from '../ewaste/EWaste';
import ContactUs from '../contact/ContactUs';

import TermsAndConditions from '../terms/TermsAndConditions';
import PrivacyPolicy from '../privacy/PrivacyPolicy';

import CustomerRatings from '../home/customerRatings';

function AppRoutes() {
  return (
    <div className="min-h-screen flex flex-col">

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-1 pt-16 lg:pt-20">

        {/* Scroll to top whenever the route changes */}
        <ScrollToTop />

        <Routes>

          {/* Home */}
          <Route
            path="/"
            element={<HomePage />}
          />

          {/* Authentication */}
          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/signup"
            element={<Signup />}
          />

          {/* Booking */}
          <Route
            path="/book-appointment"
            element={<BookAppointment />}
          />

          <Route
            path="/booking-success"
            element={<BookingSuccess />}
          />

          <Route
            path="/my-bookings"
            element={<MyBookings />}
          />

          {/* Scrap & Services */}
          <Route
            path="/price-list"
            element={<PriceList />}
          />

          <Route
            path="/services"
            element={<Services />}
          />

          <Route
            path="/e-waste-scrap"
            element={<EWaste />}
          />

          {/* Contact */}
          <Route
            path="/contact-us"
            element={<ContactUs />}
          />

          {/* Legal */}
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy />}
          />

          {/* Customer Ratings */}
          <Route
            path="/customer-ratings"
            element={<CustomerRatings />}
          />

        </Routes>
      </main>

      {/* Footer */}
      <Footer />

    </div>
  );
}

export default AppRoutes;